.home {
  > main {
    display: flex;
    align-items: flex-start;
    gap: 24px;

    .posts {
      flex: 1;
    }

    .guidelines {
      position: sticky;
      top: 72px;

      width: 280px;
      min-height: 100vh;
      flex-shrink: 0;
    }
  }
}

.post-preview {
  transition: background-color 0.2s;
  &:hover {
    background-color: var(--dugout);
  }
}

.community-guidelines-chip.community-guidelines-chip {
  background: var(--primary-dugout);
  color: var(--strong);
  cursor: pointer;
}

.sort {
  .menu {
    // Dugout from hover can overflow rounded corners
    overflow: hidden;
    margin-top: 12px;
  }

  .item {
    cursor: pointer;

    &:hover {
      background-color: var(--dugout);
    }
  }
}
